import React, { memo } from 'react';
import { useWindowSize } from 'react-use';
import makeStyles from '@mui/styles/makeStyles';
import { useTrackRenderCounts } from 'modules/common/components/Render';
import { useSidePanelContext } from 'modules/rootPage/SidePanelContext';
import { useSubstituteUser } from 'modules/rootPage/hooks/useSubstituteUser';
import NotesPageContent from './NotesPageContent';
import { NoteAnimationContextProvider } from './providers';

type PageStyleProps = {
  width: number;
  pinned: boolean;
  isSubstituteUser: boolean;
};

const usePageStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    flexGrow: 1,
    overflowY: 'hidden',
    paddingTop: theme.spacing(2),
    display: 'flex'
  },
  content: {
    width: ({ width }: PageStyleProps) => width,
    paddingTop: theme.spacing(0),
    marginTop: ({ isSubstituteUser }: PageStyleProps) =>
      theme.spacing(isSubstituteUser ? 4 : 1.5),
    paddingLeft: ({ pinned }: PageStyleProps) =>
      pinned ? theme.spacing(30) : theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey[50]
  }
}));

export const NotesPage: React.FC = memo(() => {
  useTrackRenderCounts('notes-page');

  const { isSubstituteUser } = useSubstituteUser();
  const { pinned = false } = useSidePanelContext();
  const { width } = useWindowSize();
  const classes = usePageStyles({
    width,
    pinned,
    isSubstituteUser
  });
  return (
    <NoteAnimationContextProvider>
      <div className={classes.content}>
        <NotesPageContent />
      </div>
    </NoteAnimationContextProvider>
  );
});

NotesPage.displayName = 'NotesPage';
